import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {catchError, map, retry} from 'rxjs/operators';
import {Globals} from '../globals';
import {MessageService} from 'primeng/api';

export interface Result {
  data: any[];
  success: boolean;
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class TsaService {

  private URL = '';
  constructor(private http: HttpClient, private globals: Globals, private messageService: MessageService) {
  }

  public set url(url: string) {
    if(!url.toUpperCase().includes("&LIMIT="))  url += "&limit=-1";
    //  Remove the limit because the default limit on the backend is 500 lines
    this.URL = this.globals.url_root + url;
  }

  private request(): Observable<Result> {
    return this.http.get<any>(this.URL).pipe(
      retry(2),
      catchError((error: HttpErrorResponse) => {
        // alert(JSON.stringify(error));
        if(error.message) this.messageService.add({key: 'bc', severity:'error',
          summary: 'Error Message', sticky: true, detail: error.message});
        return throwError(error);
      })
    );
  }

  getData(): Observable<any> {
    return this.request().pipe(
      map((result: Result) => result.data)
    );
  }

}
